import React, { useState } from "react";
import { Card, Button, Dropdown } from "react-bootstrap";
import ChooseVoiceEditModal from "./choose_voice_edit";

const ChooseVoice = () => {
  const [selectedLanguage, setSelectedLanguage] = useState({
    code: "en-US",
    name: "English (US)",
    flag: "/assets/us.JPG",
  });

  const [showEditModal, setShowEditModal] = useState(false);

  const languages = [
    { code: "en-US", name: "English (US)", flag: "/assets/us.JPG" },
    { code: "en-GB", name: "English (UK)", flag: "/assets/united-kingdom.png" },
    { code: "de-DE", name: "German (DE)", flag: "/assets/german.png" },
  ];

  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
  };

  const handleEditClick = () => {
    setShowEditModal(true);
  };

  const handleCloseModal = () => {
    setShowEditModal(false);
  };

  const handleSaveVoice = (selectedVoice) => {
    console.log("Selected Voice:", selectedVoice);
    setShowEditModal(false);
  };

  return (
    <div className="choose-voice-container">
      <Card className="p-4 mt-4 rounded-4 border">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="fw-bold">Choose Voice</h5>
          <Button
            variant="link"
            className="purple-color text-decoration-none fw-bold"
            onClick={handleEditClick}
          >
            <img
              src="/assets/edit-1.svg"
              alt="Right Icon"
              className="me-2 pb-1"
            />
            Edit
          </Button>
        </div>
        <hr className="mb-4 border-dark-subtle" />
        <div>
          <img src="/assets/Ellipse3.svg" alt="Choose Voice" className="me-3" />
          Carola (de-DE)
        </div>
      </Card>
      <div className="language-container">
        <Card className="p-4 mt-4 rounded-4 border">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="fw-bold">Language</h5>
          </div>
          <hr className="mb-4 border-dark-subtle" />
          <Dropdown>
            <Dropdown.Toggle
              variant="outline-secondary"
              className="w-25 text-start d-flex align-items-center border"
            >
              <img
                src={selectedLanguage.flag}
                alt={selectedLanguage.name}
                className="me-2"
                style={{ width: "20px", height: "20px" }}
              />
              {selectedLanguage.name}
            </Dropdown.Toggle>
            <Dropdown.Menu className="w-25">
              {languages.map((language) => (
                <Dropdown.Item
                  key={language.code}
                  onClick={() => handleLanguageChange(language)}
                  className="d-flex align-items-center"
                >
                  <img
                    src={language.flag}
                    alt={language.name}
                    className="me-2"
                    style={{ width: "20px", height: "20px" }}
                  />
                  {language.name}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </Card>
      </div>

      <ChooseVoiceEditModal
        show={showEditModal}
        handleClose={handleCloseModal}
        handleSave={handleSaveVoice}
      />
    </div>
  );
};

export default ChooseVoice;
